<!--
  @Description 加载组件
  @Date 2021-12-22
  @Author liufu
-->
<template>
  <div class="loader"></div>
</template>

<script>
export default {

}
</script>

<style lang='less' scoped>
.loader {
  position: relative;
  width: 2.5em;
  height: 2.5em;
  transform: rotate(165deg);
}
.loader:before,
.loader:after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  display: block;
  width: 1em;
  height: 1em;
  border-radius: 0.5em;
  transform: translate(-50%, -50%);
}
.loader:before {
  animation: before 2s infinite;
}
.loader:after {
  animation: after 2s infinite;
}

@keyframes before {
  0% {
    width: 1em;
    box-shadow: 1.5em -1em rgba(225, 20, 98, 0.75),
      -1.5em 1em rgba(111, 202, 220, 0.75);
  }
  35% {
    width: 5em;
    box-shadow: 0 -1em rgba(225, 20, 98, 0.75), 0 1em rgba(111, 202, 220, 0.75);
  }
  70% {
    width: 1em;
    box-shadow: -1.5em -1em rgba(225, 20, 98, 0.75),
      1.5em 1em rgba(111, 202, 220, 0.75);
  }
  100% {
    box-shadow: 1.5em -1em rgba(225, 20, 98, 0.75),
      -1.5em 1em rgba(111, 202, 220, 0.75);
  }
}
@keyframes after {
  0% {
    height: 1em;
    box-shadow: 1em 1.5em rgba(61, 184, 143, 0.75),
      -1em -1.5em rgba(233, 169, 32, 0.75);
  }
  35% {
    height: 5em;
    box-shadow: 1em 0 rgba(61, 184, 143, 0.75), -1em 0 rgba(233, 169, 32, 0.75);
  }
  70% {
    height: 1em;
    box-shadow: 1em -1.5em rgba(61, 184, 143, 0.75),
      -1em 1.5em rgba(233, 169, 32, 0.75);
  }
  100% {
    box-shadow: 1em 1.5em rgba(61, 184, 143, 0.75),
      -1em -1.5em rgba(233, 169, 32, 0.75);
  }
}
/**
 * Attempt to center the whole thing!
 */
// html,
// body {
//   height: 100%;
// }

.loader {
  position: absolute;
  top: calc(50% - 1.25em);
  left: calc(50% - 1.25em);
}
</style>
